import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import './DesignerDetails.css';

import Nav from '../components/layout/nav';

const DesignerDetails = () => {

  const navigate = useNavigate();

  const { state } = useLocation();

  if (!state) {
    return null;
  }

  return (

    <div className='hcontainer'>
      <div className="phoneContainer detailsPage">

      <div
        className="backkBtn"
        onClick={() => navigate(-1)}
      >
        ←
      </div>

      <div className="heroImageWrap">

        <img
          src={state.bg}
          className="heroImage"
          alt=""
        />

        <div className="imageOverlay" />

      </div>
      <div className="content">

        <h1 className="name">
          {state.name}
        </h1>

        <p className="desssstyle">
          {state.style}
        </p>

        <div className="divider" />

        <p className="bio">
          {state.bio}
        </p>

        <div className="stats">

          <div className="stat">
            <h3>Style</h3>
            <p>{state.style}</p>
          </div>

          <div className="stat">
            <h3>Location</h3>
            <p>{state.location}</p>
          </div>

          <div className="stat">
            <h3>Year</h3>
            <p>{state.year}</p>
          </div>

        </div>

        <button className="followBtn">
          <span>Follow Designer</span>
        </button>

      </div>

      <Nav />

    </div>
    </div>
  );
};

export default DesignerDetails;